import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './source-code-review.css'

const SourceCodeReview = (props) => {
  return (
    <div className="source-code-review-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="Source-Code-Review - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/source-code-review"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-section source-code-review-hero-section">
        <video
          src="https://videos.pexels.com/video-files/5473968/5473968-hd_2048_1080_25fps.mp4"
          loop="true"
          muted="true"
          poster="https://images.pexels.com/videos/5473968/pictures/preview-0.jpg"
          autoPlay="true"
          playsInline="true"
          className="hero-video"
        ></video>
        <div className="hero-overlay"></div>
        <div className="hero-content source-code-review-hero-content">
          <div className="source-code-review-hero-content-wrapper">
            <h1 className="hero-title">Source Code Review</h1>
            <p className="hero-subtitle">
              Comprehensive static analysis identifying security flaws,
              vulnerabilities, and compliance gaps with actionable remediation
              guidance for secure software development.
            </p>
            <div className="source-code-review-hero-actions">
              <a href="#contact">
                <div className="btn-primary btn btn-lg">
                  <span>Request Code Assessment</span>
                </div>
              </a>
              <a href="#process">
                <div className="btn btn-lg btn-outline">
                  <span style={{ color: 'black' }}>Explore Our Process</span>
                  
                </div>
              </a>
            </div>
            <div className="source-code-review-hero-stats">
              <div className="source-code-review-hero-stat-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
                <div className="hero-stat-info">
                  <span className="source-code-review-hero-stat-value">
                    10+
                  </span>
                  <span className="source-code-review-hero-stat-label">
                    Code Reviews Expert
                  </span>
                </div>
              </div>
              <div className="source-code-review-hero-stat-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <div className="hero-stat-info">
                  <span className="source-code-review-hero-stat-value">
                    15+
                  </span>
                  <span className="source-code-review-hero-stat-label">
                    Languages Supported
                  </span>
                </div>
              </div>
              <div className="source-code-review-hero-stat-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <div className="hero-stat-info">
                  <span className="source-code-review-hero-stat-value">
                    10K+
                  </span>
                  <span className="source-code-review-hero-stat-label">
                    Vulnerabilities Found
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="source-code-review-features-section">
        <div className="source-code-review-features-container features-container">
          <div className="source-code-review-features-header features-header">
            <h2 className="section-title">
              Enterprise-Grade Static Code Analysis
            </h2>
            <p className="section-subtitle">
              Our comprehensive source code review service combines automated
              SAST tooling with expert manual analysis to identify security
              flaws, compliance violations, and coding vulnerabilities before
              they reach production.
            </p>
          </div>
          <div className="source-code-review-features-grid">
            <div className="source-code-review-feature-card">
              <div className="source-code-review-feature-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m13 13.5l2-2.5l-2-2.5M21 21l-4.3-4.3M9 8.5L7 11l2 2.5"></path>
                    <circle r="8" cx="11" cy="11"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="source-code-review-feature-title">
                Automated SAST Engine
              </h3>
              <p className="source-code-review-feature-description">
                Industry-leading static application security testing tools scan
                your codebase for known vulnerabilities, insecure coding
                patterns, and security weaknesses across multiple programming
                languages and frameworks.
              </p>
              <ul className="feature-list">
                <li>
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>SQL injection detection</span>
                </li>
                <li>
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>XSS vulnerability identification</span>
                </li>
                <li>
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Authentication flaw detection</span>
                </li>
                <li>
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Sensitive data exposure analysis</span>
                </li>
              </ul>
            </div>
            <div className="source-code-review-feature-card">
              <div className="source-code-review-feature-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="source-code-review-feature-title">
                Expert Manual Review
              </h3>
              <p className="source-code-review-feature-description">
                Our certified security experts perform deep manual code analysis
                to identify business logic flaws, architectural vulnerabilities,
                and complex security issues that automated tools cannot detect.
              </p>
              <ul className="feature-list">
                <li>
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Business logic vulnerability assessment</span>
                </li>
                <li>
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Authorization bypass testing</span>
                </li>
                <li>
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Cryptographic implementation review</span>
                </li>
                <li>
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Race condition identification</span>
                </li>
              </ul>
            </div>
            <div className="source-code-review-feature-card">
              <div className="source-code-review-feature-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="source-code-review-feature-title">
                Actionable Remediation
              </h3>
              <p className="source-code-review-feature-description">
                Receive prioritized findings with detailed remediation guidance,
                code snippets, and security best practices to efficiently
                address vulnerabilities and strengthen your application&apos;s
                security posture.
              </p>
              <ul className="feature-list">
                <li>
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Risk-based vulnerability prioritization</span>
                </li>
                <li>
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Step-by-step fix documentation</span>
                </li>
                <li>
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Secure code examples provided</span>
                </li>
                <li>
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Developer remediation support</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="source-code-review-services-section">
        <div className="services-container source-code-review-services-container">
          <div className="source-code-review-services-header services-header">
            <h2 className="section-title">Comprehensive Code Review Scope</h2>
            <p className="section-subtitle">
              Our source code analysis covers a wide range of programming
              languages, architectures, and development environments to ensure
              thorough security assessment across your entire technology stack.
            </p>
          </div>
          <div className="source-code-review-services-grid">
            <div className="source-code-review-service-card">
              <div className="service-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="source-code-review-service-title">
                Multi-Language Support
              </h3>
              <p className="source-code-review-service-description">
                Comprehensive analysis for Java, .NET, Python, PHP, JavaScript,
                Ruby, Go, C/C++, Swift, Kotlin, and more with language-specific
                security pattern recognition.
              </p>
            </div>
            <div className="source-code-review-service-card">
              <div className="service-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5m-10 4.5L8 15l2 2.5m4-5l2 2.5l-2 2.5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="source-code-review-service-title">
                Web Applications
              </h3>
              <p className="source-code-review-service-description">
                Deep security review of front-end and back-end code, API
                endpoints, authentication mechanisms, session management, and
                data validation layers.
              </p>
            </div>
            <div className="source-code-review-service-card">
              <div className="service-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="source-code-review-service-title">
                Mobile Applications
              </h3>
              <p className="source-code-review-service-description">
                iOS and Android source code security analysis covering insecure
                data storage, weak cryptography, improper platform usage, and
                code obfuscation gaps.
              </p>
            </div>
            <div className="source-code-review-service-card">
              <div className="service-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M10 10.5L8 13l2 2.5m4-5l2 2.5l-2 2.5"></path>
                    <path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z"></path>
                  </g>
                </svg>
              </div>
              <h3 className="source-code-review-service-title">
                API &amp; Microservices
              </h3>
              <p className="source-code-review-service-description">
                RESTful API, GraphQL, and microservice architecture review
                focusing on authorization, input validation, rate limiting, and
                inter-service communication security.
              </p>
            </div>
            <div className="source-code-review-service-card">
              <div className="service-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M14 2v5a1 1 0 0 0 1 1h5m-10 4.5L8 15l2 2.5m4-5l2 2.5l-2 2.5"></path>
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                  </g>
                </svg>
              </div>
              <h3 className="source-code-review-service-title">
                Legacy Systems
              </h3>
              <p className="source-code-review-service-description">
                Security assessment of legacy codebases, identifying outdated
                libraries, deprecated functions, and modernization opportunities
                while maintaining business continuity.
              </p>
            </div>
            <div className="source-code-review-service-card">
              <div className="service-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="source-code-review-service-title">
                Cloud-Native Applications
              </h3>
              <p className="source-code-review-service-description">
                Container security, serverless function analysis,
                Infrastructure-as-Code review, and cloud provider SDK
                implementation assessment for AWS, Azure, and GCP.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="process-section source-code-review-process-section">
        <div className="process-container source-code-review-process-container">
          <div className="source-code-review-process-header process-header">
            <h2 className="section-title">Our Code Review Methodology</h2>
            <p className="section-subtitle">
              A structured, repeatable process combining automated SAST tooling
              with expert manual analysis to deliver comprehensive security
              assessments and actionable remediation guidance.
            </p>
          </div>
          <div className="process-timeline">
            <div className="source-code-review-process-step">
              <div className="source-code-review-process-step-number">
                <span>01</span>
              </div>
              <div className="source-code-review-process-step-content">
                <h3 className="source-code-review-process-step-title">
                  Scope Definition &amp; Code Collection
                </h3>
                <p className="source-code-review-process-step-description">
                  We collaborate with your development team to define the review
                  scope, identify critical modules, establish security
                  objectives, and securely collect source code repositories with
                  appropriate access controls and confidentiality agreements.
                </p>
                <div className="process-step-deliverables">
                  <span className="process-deliverable-label">
                    Deliverables:
                  </span>
                  <ul className="process-deliverable-list">
                    <li>
                      <span>Engagement charter</span>
                    </li>
                    <li>
                      <span>Scope documentation</span>
                    </li>
                    <li>
                      <span>Secure code transfer protocol</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="source-code-review-process-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
            <div className="source-code-review-process-step">
              <div className="source-code-review-process-step-number">
                <span>02</span>
              </div>
              <div className="source-code-review-process-step-content">
                <h3 className="source-code-review-process-step-title">
                  Automated SAST Scanning
                </h3>
                <p className="source-code-review-process-step-description">
                  Deploy industry-leading static analysis tools configured with
                  custom rulesets for your technology stack. Automated scans
                  identify common vulnerabilities, insecure coding patterns,
                  dependency risks, and compliance violations across the entire
                  codebase.
                </p>
                <div className="process-step-deliverables">
                  <span className="process-deliverable-label">
                    Deliverables:
                  </span>
                  <ul className="process-deliverable-list">
                    <li>
                      <span>Raw SAST findings report</span>
                    </li>
                    <li>
                      <span>Vulnerability heat map</span>
                    </li>
                    <li>
                      <span>Dependency vulnerability analysis</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="source-code-review-process-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m13 13.5l2-2.5l-2-2.5M21 21l-4.3-4.3M9 8.5L7 11l2 2.5"></path>
                    <circle r="8" cx="11" cy="11"></circle>
                  </g>
                </svg>
              </div>
            </div>
            <div className="source-code-review-process-step">
              <div className="source-code-review-process-step-number">
                <span>03</span>
              </div>
              <div className="source-code-review-process-step-content">
                <h3 className="source-code-review-process-step-title">
                  Expert Manual Code Analysis
                </h3>
                <p className="source-code-review-process-step-description">
                  Our certified security engineers perform deep manual review of
                  critical code paths, business logic, authentication flows, and
                  authorization mechanisms. This phase identifies sophisticated
                  vulnerabilities that automated tools cannot detect.
                </p>
                <div className="process-step-deliverables">
                  <span className="process-deliverable-label">
                    Deliverables:
                  </span>
                  <ul className="process-deliverable-list">
                    <li>
                      <span>Business logic vulnerability findings</span>
                    </li>
                    <li>
                      <span>Authorization bypass scenarios</span>
                    </li>
                    <li>
                      <span>Architectural security recommendations</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="source-code-review-process-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
            </div>
            <div className="source-code-review-process-step">
              <div className="source-code-review-process-step-number">
                <span>04</span>
              </div>
              <div className="source-code-review-process-step-content">
                <h3 className="source-code-review-process-step-title">
                  Findings Validation &amp; Prioritization
                </h3>
                <p className="source-code-review-process-step-description">
                  All findings undergo rigorous validation to eliminate false
                  positives. Vulnerabilities are classified by severity,
                  exploitability, and business impact using industry-standard
                  frameworks (CVSS, OWASP). Critical issues are escalated
                  immediately.
                </p>
                <div className="process-step-deliverables">
                  <span className="process-deliverable-label">
                    Deliverables:
                  </span>
                  <ul className="process-deliverable-list">
                    <li>
                      <span>Validated findings catalog</span>
                    </li>
                    <li>
                      <span>Risk-rated vulnerability matrix</span>
                    </li>
                    <li>
                      <span>Executive risk summary</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="source-code-review-process-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
            <div className="source-code-review-process-step">
              <div className="source-code-review-process-step-number">
                <span>05</span>
              </div>
              <div className="source-code-review-process-step-content">
                <h3 className="source-code-review-process-step-title">
                  Remediation Guidance &amp; Reporting
                </h3>
                <p className="source-code-review-process-step-description">
                  Comprehensive final report delivered with detailed remediation
                  guidance, secure code examples, and developer-friendly fix
                  instructions. Each vulnerability includes context,
                  reproduction steps, impact analysis, and priority
                  recommendations.
                </p>
                <div className="process-step-deliverables">
                  <span className="process-deliverable-label">
                    Deliverables:
                  </span>
                  <ul className="process-deliverable-list">
                    <li>
                      <span>Executive summary report</span>
                    </li>
                    <li>
                      <span>Technical findings report</span>
                    </li>
                    <li>
                      <span>Remediation playbook</span>
                    </li>
                    <li>
                      <span>Secure coding recommendations</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="source-code-review-process-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
            </div>
            <div className="source-code-review-process-step">
              <div className="source-code-review-process-step-number">
                <span>06</span>
              </div>
              <div className="source-code-review-process-step-content">
                <h3 className="source-code-review-process-step-title">
                  Remediation Support &amp; Re-testing
                </h3>
                <p className="source-code-review-process-step-description">
                  Ongoing support during the remediation phase including
                  developer consultations, secure coding workshops, and
                  validation testing to confirm vulnerabilities have been
                  properly addressed without introducing new security issues.
                </p>
                <div className="process-step-deliverables">
                  <span className="process-deliverable-label">
                    Deliverables:
                  </span>
                  <ul className="process-deliverable-list">
                    <li>
                      <span>Developer Q&amp;A sessions</span>
                    </li>
                    <li>
                      <span>Re-test validation report</span>
                    </li>
                    <li>
                      <span>Security posture improvement metrics</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="source-code-review-process-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M18 6L7 17l-5-5m20-2l-7.5 7.5L13 16"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="source-code-review-casestudies-section">
        <div className="source-code-review-casestudies-container">
          <div className="casestudies-header source-code-review-casestudies-header">
            <h2 className="section-title">
              Vulnerability Findings &amp; Risk Ratings
            </h2>
            <p className="section-subtitle">
              Our static analysis delivers comprehensive findings with
              CVSS-based risk ratings, OWASP mappings, and detailed remediation
              guidance to help your team prioritize and address security
              vulnerabilities efficiently.
            </p>
          </div>
          <div className="casestudies-table-wrapper">
            <table className="casestudies-table">
              <thead>
                <tr>
                  <th>
                    <span>Vulnerability Type</span>
                  </th>
                  <th>
                    <span>CVSS Score</span>
                  </th>
                  <th>
                    <span>Risk Rating</span>
                  </th>
                  <th>
                    <span>OWASP Category</span>
                  </th>
                  <th>
                    <span>Common In</span>
                  </th>
                  <th>
                    <span>Remediation Priority</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="casestudies-finding">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>SQL Injection Vulnerability</span>
                    </div>
                  </td>
                  <td>
                    <span className="casestudies-score">9.8</span>
                  </td>
                  <td>
                    <span className="casestudies-badge-critical casestudies-badge">
                      Critical
                    </span>
                  </td>
                  <td>
                    <span>A03:2021 Injection</span>
                  </td>
                  <td>
                    <span>Java, .NET, PHP, Python</span>
                  </td>
                  <td>
                    <span className="casestudies-priority-immediate casestudies-priority">
                      Immediate
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="casestudies-finding">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>Broken Authentication</span>
                    </div>
                  </td>
                  <td>
                    <span className="casestudies-score">9.1</span>
                  </td>
                  <td>
                    <span className="casestudies-badge-critical casestudies-badge">
                      Critical
                    </span>
                  </td>
                  <td>
                    <span>A07:2021 Auth Failures</span>
                  </td>
                  <td>
                    <span>Web Apps, APIs</span>
                  </td>
                  <td>
                    <span className="casestudies-priority-immediate casestudies-priority">
                      Immediate
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="casestudies-finding">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>Sensitive Data Exposure</span>
                    </div>
                  </td>
                  <td>
                    <span className="casestudies-score">8.7</span>
                  </td>
                  <td>
                    <span className="casestudies-badge casestudies-badge-high">
                      High
                    </span>
                  </td>
                  <td>
                    <span>A02:2021 Cryptographic Failures</span>
                  </td>
                  <td>
                    <span>All Languages</span>
                  </td>
                  <td>
                    <span className="casestudies-priority-urgent casestudies-priority">
                      Urgent
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="casestudies-finding">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>Cross-Site Scripting (XSS)</span>
                    </div>
                  </td>
                  <td>
                    <span className="casestudies-score">7.5</span>
                  </td>
                  <td>
                    <span className="casestudies-badge casestudies-badge-high">
                      High
                    </span>
                  </td>
                  <td>
                    <span>A03:2021 Injection</span>
                  </td>
                  <td>
                    <span>JavaScript, Web Frameworks</span>
                  </td>
                  <td>
                    <span className="casestudies-priority-urgent casestudies-priority">
                      Urgent
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="casestudies-finding">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>Insecure Deserialization</span>
                    </div>
                  </td>
                  <td>
                    <span className="casestudies-score">8.1</span>
                  </td>
                  <td>
                    <span className="casestudies-badge casestudies-badge-high">
                      High
                    </span>
                  </td>
                  <td>
                    <span>A08:2021 Software Integrity</span>
                  </td>
                  <td>
                    <span>Java, Python, .NET</span>
                  </td>
                  <td>
                    <span className="casestudies-priority-urgent casestudies-priority">
                      Urgent
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="casestudies-finding">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle r="8" cx="11" cy="11"></circle>
                          <path d="m21 21l-4.3-4.3M11 7v4m0 4h.01"></path>
                        </g>
                      </svg>
                      <span>XML External Entity (XXE)</span>
                    </div>
                  </td>
                  <td>
                    <span className="casestudies-score">6.8</span>
                  </td>
                  <td>
                    <span className="casestudies-badge casestudies-badge-medium">
                      Medium
                    </span>
                  </td>
                  <td>
                    <span>A05:2021 Security Misconfig</span>
                  </td>
                  <td>
                    <span>XML Processing Libraries</span>
                  </td>
                  <td>
                    <span className="casestudies-priority-high casestudies-priority">
                      High
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="casestudies-finding">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle r="8" cx="11" cy="11"></circle>
                          <path d="m21 21l-4.3-4.3M11 7v4m0 4h.01"></path>
                        </g>
                      </svg>
                      <span>Weak Cryptography</span>
                    </div>
                  </td>
                  <td>
                    <span className="casestudies-score">6.5</span>
                  </td>
                  <td>
                    <span className="casestudies-badge casestudies-badge-medium">
                      Medium
                    </span>
                  </td>
                  <td>
                    <span>A02:2021 Cryptographic Failures</span>
                  </td>
                  <td>
                    <span>All Languages</span>
                  </td>
                  <td>
                    <span className="casestudies-priority-high casestudies-priority">
                      High
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="casestudies-finding">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle r="8" cx="11" cy="11"></circle>
                          <path d="m21 21l-4.3-4.3M11 7v4m0 4h.01"></path>
                        </g>
                      </svg>
                      <span>Insufficient Logging &amp; Monitoring</span>
                    </div>
                  </td>
                  <td>
                    <span className="casestudies-score">5.3</span>
                  </td>
                  <td>
                    <span className="casestudies-badge casestudies-badge-medium">
                      Medium
                    </span>
                  </td>
                  <td>
                    <span>A09:2021 Logging Failures</span>
                  </td>
                  <td>
                    <span>Backend Systems</span>
                  </td>
                  <td>
                    <span className="casestudies-priority-medium casestudies-priority">
                      Medium
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="casestudies-finding">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>Hard-coded Credentials</span>
                    </div>
                  </td>
                  <td>
                    <span className="casestudies-score">7.2</span>
                  </td>
                  <td>
                    <span className="casestudies-badge casestudies-badge-high">
                      High
                    </span>
                  </td>
                  <td>
                    <span>A07:2021 Auth Failures</span>
                  </td>
                  <td>
                    <span>Configuration Files</span>
                  </td>
                  <td>
                    <span className="casestudies-priority-urgent casestudies-priority">
                      Urgent
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="casestudies-finding">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>Outdated Dependencies</span>
                    </div>
                  </td>
                  <td>
                    <span className="casestudies-score">6.1</span>
                  </td>
                  <td>
                    <span className="casestudies-badge casestudies-badge-medium">
                      Medium
                    </span>
                  </td>
                  <td>
                    <span>A06:2021 Vulnerable Components</span>
                  </td>
                  <td>
                    <span>All Technology Stacks</span>
                  </td>
                  <td>
                    <span className="casestudies-priority-high casestudies-priority">
                      High
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="casestudies-finding">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>CSRF Protection Missing</span>
                    </div>
                  </td>
                  <td>
                    <span className="casestudies-score">5.8</span>
                  </td>
                  <td>
                    <span className="casestudies-badge casestudies-badge-medium">
                      Medium
                    </span>
                  </td>
                  <td>
                    <span>A01:2021 Broken Access Control</span>
                  </td>
                  <td>
                    <span>Web Applications</span>
                  </td>
                  <td>
                    <span className="casestudies-priority-medium casestudies-priority">
                      Medium
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="casestudies-finding">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>Path Traversal Vulnerability</span>
                    </div>
                  </td>
                  <td>
                    <span className="casestudies-score">7.7</span>
                  </td>
                  <td>
                    <span className="casestudies-badge casestudies-badge-high">
                      High
                    </span>
                  </td>
                  <td>
                    <span>A01:2021 Broken Access Control</span>
                  </td>
                  <td>
                    <span>File Upload Functions</span>
                  </td>
                  <td>
                    <span className="casestudies-priority-urgent casestudies-priority">
                      Urgent
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section className="source-code-review-stats-section">
        <div className="source-code-review-stats-container">
          <div className="source-code-review-stats-header">
            <h2 className="section-title">
              Compliance &amp; Regulatory Alignment
            </h2>
            <p className="section-subtitle">
              Our source code review findings are mapped to major compliance
              frameworks and industry standards, helping you demonstrate
              security due diligence and meet regulatory requirements.
            </p>
          </div>
          <div className="source-code-review-stats-grid">
            <div className="source-code-review-stat-card">
              <div className="stat-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="source-code-review-stat-title">ISO 27001</h3>
              <p className="source-code-review-stat-description">
                Findings mapped to Annex A controls including A.14.2 (Security
                in Development) and A.12.6 (Technical Vulnerability Management)
                for ISO 27001 compliance evidence.
              </p>
              <div className="source-code-review-stat-value">
                <span>Control A.14.2.1 - A.14.2.9</span>
              </div>
            </div>
            <div className="source-code-review-stat-card">
              <div className="stat-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="source-code-review-stat-title">SOC 2 Type II</h3>
              <p className="source-code-review-stat-description">
                Code review supports SOC 2 trust service criteria including
                CC6.6 (Logical and Physical Access Controls) and CC7.1 (System
                Operations) for audit readiness.
              </p>
              <div className="source-code-review-stat-value">
                <span>CC6.6, CC7.1, CC8.1</span>
              </div>
            </div>
            <div className="source-code-review-stat-card">
              <div className="stat-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="source-code-review-stat-title">PCI-DSS v4.0</h3>
              <p className="source-code-review-stat-description">
                Secure code review aligns with Requirement 6 (Develop and
                Maintain Secure Systems) including 6.2.4 (Custom Software
                Security) and 6.3.2 (Review of Code Changes).
              </p>
              <div className="source-code-review-stat-value">
                <span>Requirement 6.2.4, 6.3.2</span>
              </div>
            </div>
            <div className="source-code-review-stat-card">
              <div className="stat-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="source-code-review-stat-title">OWASP ASVS</h3>
              <p className="source-code-review-stat-description">
                Findings correlated with OWASP Application Security Verification
                Standard (ASVS) Level 2 and Level 3 requirements for
                authentication, access control, and cryptography.
              </p>
              <div className="source-code-review-stat-value">
                <span>ASVS v4.0 Level 2/3</span>
              </div>
            </div>
            <div className="source-code-review-stat-card">
              <div className="stat-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="source-code-review-stat-title">
                GDPR &amp; Privacy
              </h3>
              <p className="source-code-review-stat-description">
                Privacy-focused code analysis identifies personal data handling
                issues, consent mechanisms, and data protection by design
                principles required by GDPR Article 25 and Article 32.
              </p>
              <div className="source-code-review-stat-value">
                <span>Article 25, Article 32</span>
              </div>
            </div>
            <div className="source-code-review-stat-card">
              <div className="stat-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="source-code-review-stat-title">
                AI GRC Requirements
              </h3>
              <p className="source-code-review-stat-description">
                For AI/ML applications, code review validates model security,
                training data handling, bias detection mechanisms, and AI
                governance controls aligned with emerging AI regulations.
              </p>
              <div className="source-code-review-stat-value">
                <span>Model Security &amp; Ethics</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="source-code-review-thq-cta-section-elm cta-section source-code-review-cta-section">
        <div className="source-code-review-thq-cta-container-elm cta-container">
          <div className="source-code-review-thq-cta-card-elm source-code-review-cta-card">
            <div className="source-code-review-cta-content">
              <h2 className="section-title">Secure Your Codebase Today</h2>
              <p className="section-subtitle">
                Partner with Cysigil Security for comprehensive source code
                review that identifies vulnerabilities before they become
                breaches. Our expert team delivers actionable insights and
                remediation guidance tailored to your technology stack.
              </p>
              <div className="cta-features">
                <div className="source-code-review-cta-feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Industry-leading SAST tools</span>
                </div>
                <div className="source-code-review-cta-feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Certified security experts</span>
                </div>
                <div className="source-code-review-cta-feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Compliance-ready reports</span>
                </div>
                <div className="source-code-review-cta-feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Ongoing remediation support</span>
                </div>
              </div>
              <div className="source-code-review-cta-actions">
                <div className="btn-primary btn-xl btn">
                  <span>Schedule Assessment</span>
                </div>
              </div>
              <div className="source-code-review-thq-cta-contact-elm cta-contact"></div>
            </div>
            <div className="source-code-review-cta-image">
              <img
                alt="Two cybersecurity experts in hoodies study data on screens in a dimly lit room, symbolizing cyber defense."
                src="https://images.pexels.com/photos/5380659/pexels-photo-5380659.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              />
            </div>
          </div>
        </div>
      </section>
      <div className="source-code-review-container2">
        <div className="source-code-review-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.feature-card, .service-card, .stat-card {
  transition: none;
}
.feature-card:hover, .service-card:hover, .stat-card:hover {
  transform: none;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="source-code-review-container4">
        <div className="source-code-review-container5">
          <Script
            html={`<script defer data-name="scroll-animations">
(function(){
  const observerOptions = {
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px",
  }

  const fadeInElements = document.querySelectorAll(".feature-card, .service-card, .stat-card, .process-step")

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "0"
        entry.target.style.transform = "translateY(20px)"
        entry.target.style.transition = "opacity 0.5s ease, transform 0.5s ease"

        setTimeout(() => {
          entry.target.style.opacity = "1"
          entry.target.style.transform = "translateY(0)"
        }, 100)

        observer.unobserve(entry.target)
      }
    })
  }, observerOptions)

  fadeInElements.forEach((el) => observer.observe(el))
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default SourceCodeReview
